import { useState } from 'react'
import type { FormEvent } from 'react'
import { signInWithGoogle, supabase } from '../lib/supabase'
import { ErrorBox, Field, TextInput } from './ui'

// Login centralizado. Google (1 clique) aparece SÓ p/ a equipe (/interno);
// o cliente (/painel) vê apenas o link de acesso por e-mail (sem confusão).
export function Login({ staff = false }: { staff?: boolean }) {
  const [email, setEmail] = useState('')
  const [enviado, setEnviado] = useState(false)
  const [erro, setErro] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  async function entrarGoogle() {
    setErro(null)
    const { error } = await signInWithGoogle(window.location.href)
    if (error) setErro(error.message)
  }

  async function enviarMagic(e: FormEvent) {
    e.preventDefault()
    setErro(null)
    setBusy(true)
    const { error } = await supabase.auth.signInWithOtp({ email, options: { emailRedirectTo: window.location.href } })
    setBusy(false)
    if (error) setErro(error.message)
    else setEnviado(true)
  }

  return (
    <div className="flex min-h-[65vh] items-center justify-center">
      <div className="card w-full max-w-md">
        <h1 className="text-xl font-semibold text-pfa-navy">{staff ? 'Acesso da equipe' : 'Acompanhar meu caso'}</h1>

        {staff && (
          <>
            <button onClick={entrarGoogle} className="btn-accent mt-4 w-full">
              Entrar com Google
            </button>
            <div className="my-4 flex items-center gap-3 text-xs text-pfa-slate/60">
              <span className="h-px flex-1 bg-pfa-line" /> ou <span className="h-px flex-1 bg-pfa-line" />
            </div>
          </>
        )}

        {enviado ? (
          <p className="mt-4 text-sm text-pfa-slate">
            Enviamos um link de acesso para <strong>{email}</strong>. Abra-o neste dispositivo para entrar.
          </p>
        ) : (
          <form onSubmit={enviarMagic} className={staff ? '' : 'mt-4'}>
            <Field label={staff ? 'Entrar por e-mail (link de acesso)' : 'Seu e-mail'}>
              <TextInput
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="seu@email.com"
                required
              />
            </Field>
            <button className={`mt-2 w-full ${staff ? 'btn-ghost' : 'btn-accent'}`} type="submit" disabled={busy}>
              {busy ? 'Enviando…' : 'Receber link de acesso'}
            </button>
          </form>
        )}

        <ErrorBox message={erro} />
      </div>
    </div>
  )
}
